module.exports = __webpack_public_path__ + "media/images/icons/outlined/weibo-bb3ad66855da4d811fcf544a39b655ab.svg";